import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { BASE_FONT_FAMILY, PLACEHOLDER_COLOR } = constants;

let styles = {
  base: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    fontSize: '2em',
    fontWeight: 500,
    textTransform: 'capitalize',
    boxSizing: 'border-box',
    borderBottom: `1px solid ${PLACEHOLDER_COLOR}`,
    paddingBottom: 15
  },
  title: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    color: PLACEHOLDER_COLOR,
    marginLeft: 10,
    cursor: 'pointer'
  },
  btn: {
    textTransform: 'capitalize'
  },
  input: {
    border: 0,
    fontSize: '1em',
    fontFamily: BASE_FONT_FAMILY
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/titlebar/TitleBar.styles.js